import { Container } from "./CommonStyles";
import { TextFieldProps } from "./TextField";
import { styled } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

/**
 * Skeleton for the TextField component
 */
export const TextFieldSkeleton = ({ inline = false }: Pick<TextFieldProps, "inline">) => {
    return (
        <StyledContainer inline={inline}>
            <StyledSkeleton variant={"rectangular"} width={50} height={"1em"} />
            <StyledSkeleton variant={"rectangular"} width={"100%"} height={"2em"} />
        </StyledContainer>
    );
};

const StyledContainer = styled(Container)(({ theme }) => ({
    gap: theme.spacing(1),
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));
